import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {getEditorAddAppButtonTitle} from '../services/app-type-detector';
import {addApp} from '../services/app-flow';

const getClassNames = (title, large, primaryStyle) => {
  const plus = title === 'application.action.addToSite' ||
    title === 'editor.application.action.addToSite' ||
    title === 'application.action.addAgain';

  if (primaryStyle) {
    return classNames('button-primary', {'plus-sign': plus});
  } else {
    return classNames('button-blue', {'button': !large, 'button-blue-large': large, 'plus-sign': plus});
  }
};

class AddToSiteButton extends React.Component {

  constructor(props) {
    super(props);
    this.handleAddAppClick = this.handleAddAppClick.bind(this);
  }

  handleAddAppClick(ev) {
    ev.preventDefault();
    const config = {
      formatMessage: this.props.intl.formatMessage,
      query: this.props.query,
      market: this.props.market,
      experiments: this.props.experiments,
      fullUrl: this.props.fullUrl
    };

    addApp(this.props.app, this.props.biPosition, this.props.dispatch.bind(this), config);
  }

  render() {
    const title = getEditorAddAppButtonTitle(this.props.app);

    return (
      <a className={getClassNames(title, this.props.largeButton, this.props.primaryStyle)} onClick={this.handleAddAppClick} href="#">
        <FormattedMessage id={title}/>
      </a>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    biPosition: PropTypes.number,
    largeButton: PropTypes.bool,
    primaryStyle: PropTypes.bool,
    dispatch: PropTypes.func,
    query: PropTypes.object,
    market: PropTypes.string,
    experiments: PropTypes.object,
    fullUrl: PropTypes.string,
    intl: intlShape
  };
}

function mapStateToProps(state) {
  return {
    query: state.mode.query,
    market: state.mode.market,
    experiments: state.mode.experiments,
    fullUrl: state.mode.fullUrl
  };
}

export default connect(mapStateToProps)(injectIntl(AddToSiteButton));



// WEBPACK FOOTER //
// ./components/Add-to-site-button.js